import { AfterViewInit, Component, EventEmitter, Input, NgModule, OnDestroy, OnInit, Output } from '@angular/core';
import { DialogService } from '@app/services/dialog.service';
import { User } from '@app/models/user.model';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { ComponentsSharedModule } from '@app/components/components-shared.module';
import { Observable, Subject, takeUntil } from 'rxjs';
import { DaiDbService } from '@app/services/indexdb/dai-db.service';
import { UserSelectMode } from '@app/services/modal.model';

@Component({
  selector: 'app-user-select',
  templateUrl: './user-select.component.html',
  styleUrls: ['./user-select.component.scss'],
})
export class UserSelectComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() userList!: User[];
  @Input() style: Object = {};
  // @Input() autoOpen: boolean = false;
  @Output() userChange = new EventEmitter<User>();
  @Input() triggerOpen$?: Subject<boolean>;
  onDestroy: Subject<void> = new Subject<void>();
  private openObservable!: Observable<boolean>;
  // private openSubscription?: Subscription;
  isdbReady = false;
  constructor(private dialog: DialogService, public daiIndexDB: DaiDbService) { }

  ngAfterViewInit(): void {
    // throw new Error('Method not implemented.');
    this.openObservable.pipe(takeUntil(this.onDestroy)).subscribe(() => this.openSearchUser());
  }

  ngOnDestroy(): void {
    this.onDestroy.next();
  }

  ngOnInit(): void {
    if (this.triggerOpen$) {
      this.openObservable = this.triggerOpen$?.asObservable();
    }
  }


  openSearchUser() {
    const modalDialog = this.dialog.select({ mode: UserSelectMode.DAI });
    modalDialog.afterClosed().subscribe((result) => {
      if (result) {
        this.userChange.emit(result);
      }
      sessionStorage.setItem('userOpen', '1');
    });
  }
}

@NgModule({
  declarations: [UserSelectComponent],
  imports: [
    CommonModule,
    SharedModule,
    ComponentsSharedModule,
  ],
  exports: [UserSelectComponent]
})
export class UserSelectModule { }
